import { render, staticRenderFns } from "./LocalAudience.vue?vue&type=template&id=7810dcb0&"
import script from "./LocalAudience.vue?vue&type=script&lang=js&"
export * from "./LocalAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports